import React from "react";

import "./PageHeading.css";

function PageHeading({ heading }) {
  return (
    <div className="page-heading">
      <h1>{heading}</h1>
    </div>
  );
}

export default PageHeading;
